import { render, staticRenderFns } from "./ListArbos.vue?vue&type=template&id=00d95585&scoped=true&"
import script from "./ListArbos.vue?vue&type=script&lang=js&"
export * from "./ListArbos.vue?vue&type=script&lang=js&"
import style0 from "./ListArbos.vue?vue&type=style&index=0&id=00d95585&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d95585",
  null
  
)

export default component.exports